import z from "zod/v4";
import { leagueIdSchema } from "../enums/LeagueId.ts";

export const liveGamePeriodTypeSchema = z.union([
  z.literal("Q"),
  z.literal("OT"),
  z.literal("HT"),
]);
export type LiveGamePeriodType = z.infer<typeof liveGamePeriodTypeSchema>;

export const liveGamePeriodSchema = z.object({
  seq: z.number(),
  num: z.number(),
  type: liveGamePeriodTypeSchema,
});
export type LiveGamePeriod = z.infer<typeof liveGamePeriodSchema>;

export const basketballScoreboardTeamSchema = z.object({
  teamId: z.string(),
  points: z.number(),
  remainingTimeouts: z.number().nullish(),
  bonus: z.boolean(),
  fouls: z.number().nullish(),
});
export type BasketballScoreboardTeam = z.infer<
  typeof basketballScoreboardTeamSchema
>;

export const basketballScoreboardClockSchema = z.object({
  s: z.number(),
  fmt: z.string(),
  shot: z.number().nullish(),
  shotFmt: z.string().nullish(),
});
export type BasketballScoreboardClock = z.infer<
  typeof basketballScoreboardClockSchema
>;

export const basketballScoreboardSchema = z.object({
  scoreboard_type: z.literal("BasketballScoreboard"),
  leagueId: leagueIdSchema,
  eventId: z.string(),
  period: liveGamePeriodSchema,
  away: basketballScoreboardTeamSchema,
  home: basketballScoreboardTeamSchema,
  clock: basketballScoreboardClockSchema,
});
export type BasketballScoreboard = z.infer<typeof basketballScoreboardSchema>;

export const liveGameScoreTimeSeriesPointSchema = z.object({
  period: liveGamePeriodSchema,
  clockSecs: z.number(),
  clockFmt: z.string(),
  aPts: z.number(),
  hPts: z.number(),
  delta: z.number().nullish(),
  aPtsE: z.number().nullish(),
  hPtsE: z.number().nullish(),
  gameSecs: z.number(),
  t: z.number(),
});
export type LiveGameScoreTimeSeriesPoint = z.infer<
  typeof liveGameScoreTimeSeriesPointSchema
>;

export const eventStatusSchema = z.union([
  z.literal("pregame"),
  z.literal("live"),
  z.literal("postgame"),
  z.literal("closed"),
  z.literal("postponed"),
  z.literal("cancelled"),
  z.literal("other"),
]);
export type EventStatus = z.infer<typeof eventStatusSchema>;

export const scoresFeedGameTeamSchema = z.object({
  teamId: z.string(),
  name: z.string(),
  market: z.string(),
  points: z.number(),
});
export type ScoresFeedGameTeam = z.infer<typeof scoresFeedGameTeamSchema>;

export const basketballScoresFeedItemSchema = z.object({
  scores_feed_item_type: z.literal("BasketballScoresFeedItem"),
  eventId: z.string(),
  status: eventStatusSchema,
  period: liveGamePeriodSchema,
  away: scoresFeedGameTeamSchema,
  home: scoresFeedGameTeamSchema,
  clock: basketballScoreboardClockSchema,
  sparkline: z.array(liveGameScoreTimeSeriesPointSchema),
});
export type BasketballScoresFeedItem = z.infer<
  typeof basketballScoresFeedItemSchema
>;

export const scoreTimeSeriesPointSchema = z.object({
  leagueId: leagueIdSchema,
  eventId: z.string(),
  point: liveGameScoreTimeSeriesPointSchema,
});
export type ScoreTimeSeriesPoint = z.infer<typeof scoreTimeSeriesPointSchema>;

export const anyScoresFeedItemSchema = z.union([
  basketballScoresFeedItemSchema,
]);
export type AnyScoresFeedItem = z.infer<typeof anyScoresFeedItemSchema>;
export const anyScoreboardSchema = z.union([basketballScoreboardSchema]);
export type AnyScoreboard = z.infer<typeof anyScoreboardSchema>;
